<script>
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import HonorValidatorTab from "./components/HonorValidatorTab.vue";
import HonorPenyusunSoalTab from "./components/HonorPenyusunSoalTab.vue";

export default {
  page: {
    title: "Perhitungan Honor",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    HonorValidatorTab,
    HonorPenyusunSoalTab,
  },
  data() {
    return {
      title: "Perhitungan Honor",
      items: [],
      downloadingZip: null, // 'ktp' | 'npwp' | null
    };
  },
  methods: {
    async downloadZip(type) {
      this.downloadingZip = type;

      try {
        const response = await axios({
          method: "get",
          url:
            process.env.VUE_APP_BACKEND_URL_VERSION +
            `verifikasi/perhitungan-honor/validator/download-zip-${type}`,
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        const fileName = `${type}_validator_${Math.floor(Date.now() / 1000)}.zip`;
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        let message = `Gagal mengunduh ZIP ${type.toUpperCase()}.`;

        if (error.response?.data instanceof Blob) {
          try {
            const text = await error.response.data.text();
            const parsed = JSON.parse(text);
            message = parsed?.meta?.message || message;
          } catch {
            // ignore parse error, keep default message
          }
        } else if (error.response?.data?.meta?.message) {
          message = error.response.data.meta.message;
        }

        Swal.fire({ icon: "error", title: "Oops...", text: message });
      } finally {
        this.downloadingZip = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="d-flex flex-wrap justify-content-end gap-2 mb-3">
      <button
        class="btn btn-success btn-sm"
        :disabled="downloadingZip !== null"
        @click="downloadZip('ktp')"
      >
        <span v-if="downloadingZip === 'ktp'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="fa fa-file-archive me-1"></i> Download Semua KTP
      </button>
      <button
        class="btn btn-success btn-sm"
        :disabled="downloadingZip !== null"
        @click="downloadZip('npwp')"
      >
        <span v-if="downloadingZip === 'npwp'" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="fa fa-file-archive me-1"></i> Download Semua NPWP
      </button>
      <router-link :to="{ name: 'all-kompetensi-level' }" class="btn btn-light btn-sm">
        <i class="fa fa-arrow-left me-1"></i> Kembali ke Kompetensi Level
      </router-link>
    </div>

    <b-tabs class="honor-tabs" content-class="pt-3" nav-class="nav-tabs-custom">
      <b-tab title="Perhitungan Honor Validator" active>
        <HonorValidatorTab />
      </b-tab>
      <b-tab title="Perhitungan Honor Penyusun Soal">
        <HonorPenyusunSoalTab />
      </b-tab>
    </b-tabs>
  </Layout>
</template>

<style scoped>
.honor-tabs :deep(.nav-tabs-custom) {
  gap: 0.25rem;
  border-bottom-color: #e9ecef;
}

.honor-tabs :deep(.nav-link) {
  color: #6c757d;
  font-weight: 600;
  padding: 0.65rem 1rem;
}

.honor-tabs :deep(.nav-link.active) {
  color: #1f2937;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
</style>
